export default __webpack_public_path__ + "static/media/redmagic.cdaac8a3.png";